import { Guid } from 'guid-typescript';

export default () => {
  return Guid.create().toString();
};

export const isGuid = (id: string) => {
  const pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  return pattern.test(id);
};
